import React from 'react';

import * as styles from './NumericalLozenge.styles';

export interface NumericalLozengeProps {
  value: `${number}` | `${number}+`;
}

export const NumericalLozenge = ({ value }: NumericalLozengeProps) => {
  return (
    <span
      className="numericalLozenge"
      css={styles.numericalLozenge}
      data-greater-than-one-character={value.length > 1}
    >
      {value}
    </span>
  );
};
